module.exports = __webpack_public_path__ + "img/shop-hint.3c259d01.svg";